import { BibleBook } from '../../../shared/types';

/**
 * Filters the BIBLE_BOOKS array by a search query, matching against both
 * the book name and its abbreviation (case-insensitive).
 * Returns all books if the query is empty/whitespace.
 */
export const filterBooks = (query: string, books: BibleBook[]): BibleBook[] => {
  const q = query.trim().toLowerCase();
  if (q.length === 0) return books;
  return books.filter(
    (b) =>
      b.name.toLowerCase().includes(q) ||
      b.abbreviation.toLowerCase().includes(q),
  );
};

/**
 * Clamps a chapter number between 1 and the max chapter count for a book.
 */
export const clampChapter = (val: number, max: number): number =>
  Math.max(1, Math.min(val, max));

/**
 * Builds a sequential array of chapter numbers from `from` to `to` (inclusive),
 * automatically handling reversed ranges (i.e. from > to).
 * e.g. buildChapterRange(3, 5) → [3, 4, 5]
 *      buildChapterRange(5, 3) → [3, 4, 5]
 */
export const buildChapterRange = (from: number, to: number): number[] => {
  const start = Math.min(from, to);
  const end = Math.max(from, to);
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};
